import store from '../../redux/index'

const defaultSupportEmail = 'ShippingConsoleSupport@cimpress.com'

export function getSupportEmailAddress() {
  const { settings: { supportEmailAddress } } = store.getState()

  return supportEmailAddress || defaultSupportEmail
}